import React, { useState } from "react";
import { SmartLink } from "../../v2/SmartLink/SmartLink";
import { SmartImage } from "../../v2/SmartImage/SmartImage";
import ChevronDown from "@/src/media/icons/chevron-down.svg";
import clsx from "clsx";

interface FooterMenuProps {
    title: string;
    links: { title: string; url: string; target?: string; rel?: string }[];
    className?: string;
}

const FooterMenu: React.FC<FooterMenuProps> = ({ title, links, className = "" }) => {
    const [isOpen, setIsOpen] = useState(false);
    const sectionId = `footer-section-${title.replace(/\s+/g, "-").toLowerCase()}`;

    return (
        <nav aria-label={`${title} links`} className="flex flex-col gap-4 text-xs text-text-contrast md:gap-6">
            <button
                type="button"
                className="flex w-full items-center justify-between sm:pointer-events-none sm:focus:outline-none"
                aria-expanded={isOpen}
                aria-controls={sectionId}
                onClick={() => setIsOpen(!isOpen)}
                onKeyDown={e => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        setIsOpen(prev => !prev);
                    }
                }}
            >
                <h4 className="collapse-title !font-bold">{title}</h4>
                <div className="transform-y h-6 w-6 brightness-0 invert sm:hidden">
                    <SmartImage image={ChevronDown} objectFit="scale-down" className={clsx("transition-transform", isOpen ? "-rotate-180" : "")} />
                </div>
            </button>

            {/* Links get py-1 for 24px touch targets; gap-y-2 and -my-1 absorb it so the spacing looks the same */}
            <ul id={sectionId} className={clsx("grid-columns-1 -my-1 grid gap-x-1 gap-y-2 md:gap-x-8", isOpen ? "" : "max-sm:hidden", className)}>
                {links.map(item => (
                    <li key={item.url}>
                        {/* underline has to be on the link: text-decoration doesn't propagate into inline-block */}
                        <SmartLink href={item.url} target={item.target} rel={item.rel} className="inline-block py-1 underline">
                            {item.title}
                        </SmartLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default FooterMenu;
